export const PENDO_READY_EVENT = 'pendo:ready'
